import React from 'react';
import { Gift, TrendingUp } from 'lucide-react';

export function RewardsOverview() {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="text-2xl font-bold">2,500</div>
        <div className="flex items-center gap-2 text-success text-sm">
          <TrendingUp className="w-4 h-4" />
          <span>+500 this week</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="theme-card p-4">
          <div className="text-sm text-muted-foreground mb-1">Available</div>
          <div className="text-lg font-semibold">1,800 pts</div>
        </div>
        <div className="theme-card p-4">
          <div className="text-sm text-muted-foreground mb-1">Redeemed</div>
          <div className="text-lg font-semibold">700 pts</div>
        </div>
      </div>

      <button className="theme-button w-full py-2 rounded-lg flex items-center justify-center gap-2">
        <Gift className="w-4 h-4" />
        <span>Redeem Rewards</span>
      </button>
    </div>
  );
}